let initialState = {
  authParams: {
    ptoken: null,
    brand_id: [],
    theme_type: "1",
  },
  global_brands: null,
  global_category_id: null,
};

const AuthParams = (state = initialState, action) => {
  switch (action.type) {
    case "SET_AUTH_PARAMS":
      return {
        ...state,
        authParams: action.payload,
      };
    case "SET_GLOBAL_BRANDS":
      return {
        ...state,
        global_dashboard_brands: action.payload,
      };
    case "SET_GLOBAL_CATEGORY_ID":
      return {
        ...state,
        global_category_id: action.payload,
      };
    default:
      return state;
  }
};

export default AuthParams;
